import httpService from '@/core/http/http.service';
import utilities from '@/shared/utilities.service';
import siteContextStore from '@/shared/content/site-context.store';

const getCurrentLanguage = () => siteContextStore.settings.language.toLowerCase();

export class TempStoreApiClient {
    private readonly baseUrl: string = '';

    clickAndCollectChangeStore(storeId: string, sku: string): Promise<TempStoreViewModel> {
        const apiUrl = `${this.baseUrl}/api/clickandcollect/change-store?language=${getCurrentLanguage()}`;
        const request = { storeId: storeId, sku: sku };
        return httpService.post<TempStoreViewModel>(apiUrl, request).then(utilities.unwrapModel);
    }
}

export const TempStoreApiClientService = new TempStoreApiClient();

export type TempStoreViewModel = any;
